import styled from 'styled-components';
import { StyledDialogContentHeaderProps } from './types';
import { baseFlexbox, baseStyling } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledDialogContentHeader = styled.div<StyledDialogContentHeaderProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${baseStyling}
  ${baseFlexbox}

  .redsift-dialog-content-header__header {
    align-items: center;
    display: flex;
    gap: 8px;
    padding: 10px 0px;
    margin: 0px;
  }

  .redsift-dialog-content-header__subheader {
    font-family: var(--redsift-typography-body-font-family);
    font-size: var(--redsift-typography-body-font-size);
    font-weight: var(--redsift-typography-body-font-weight);
    line-height: var(--redsift-typography-body-line-height);
  }
`;
